/**
 * @flow
 * @relayHash 9d4cb1b9636ae36658106f1e16346ccb
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteItemInput = {|
  id: string
|};
export type DeleteItemMutationVariables = {|
  input: DeleteItemInput
|};
export type DeleteItemMutationResponse = {|
  +deleteItem: {|
    +deletedId: string
  |}
|};
export type DeleteItemMutation = {|
  variables: DeleteItemMutationVariables,
  response: DeleteItemMutationResponse,
|};
*/


/*
mutation DeleteItemMutation(
  $input: DeleteItemInput!
) {
  deleteItem(input: $input) {
    deletedId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteItemInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteItem",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteItemPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteItemMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteItemMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteItemMutation",
    "id": null,
    "text": "mutation DeleteItemMutation(\n  $input: DeleteItemInput!\n) {\n  deleteItem(input: $input) {\n    deletedId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8e83a21584d090bf062da8049677cda8';
module.exports = node;
